module.exports = __webpack_public_path__ + "img/fish1.eb59cb67.png";